import { Link } from "react-router-dom";
import MediaCard from "@/components/base/MediaCard";
import HeroCarousel from "./components/HeroCarousel";
import CategoryEntries from "./components/CategoryEntries";
import SectionHeader from "./components/SectionHeader";
import { mediaList } from "@/mocks/media";
import { getByType } from "@/utils/media";

export default function Home() {
  const featured = mediaList.filter((item) => item.featured);
  const movies = getByType(mediaList, "movie");
  const tvs = getByType(mediaList, "tv");
  const hotMovies = [...movies].sort((a, b) => b.rating - a.rating).slice(0, 6);
  const hotTvs = [...tvs].sort((a, b) => b.rating - a.rating).slice(0, 6);
  const latest = [...mediaList]
    .sort((a, b) => b.updatedAt.localeCompare(a.updatedAt))
    .slice(0, 8);

  return (
    <div className="min-h-screen bg-background-50">
      {featured.length > 0 ? (
        <HeroCarousel items={featured} />
      ) : (
        <div className="pt-20" />
      )}

      <CategoryEntries movieCount={movies.length} tvCount={tvs.length} />

      <section className="w-full px-4 md:px-8 mt-14 md:mt-20">
        <SectionHeader
          title="热门爱情电影精选"
          subtitle="高分口碑之作，光影里最动人的那些瞬间"
          moreTo="/category/movies"
        />
        {hotMovies.length > 0 ? (
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-5">
            {hotMovies.map((item) => (
              <MediaCard key={item.id} item={item} />
            ))}
          </div>
        ) : (
          <p className="text-sm text-foreground-500">暂无推荐内容，请稍后刷新。</p>
        )}
      </section>

      <section className="w-full px-4 md:px-8 mt-14 md:mt-20">
        <SectionHeader
          title="热门爱情电视剧精选"
          subtitle="一集入坑，追到深夜也舍不得关的那部剧"
          moreTo="/category/tv"
        />
        {hotTvs.length > 0 ? (
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-5">
            {hotTvs.map((item) => (
              <MediaCard key={item.id} item={item} />
            ))}
          </div>
        ) : (
          <p className="text-sm text-foreground-500">暂无推荐内容，请稍后刷新。</p>
        )}
      </section>

      <section className="w-full px-4 md:px-8 mt-14 md:mt-20">
        <SectionHeader
          title="最新更新"
          subtitle="按更新时间倒序，第一时间发现新的爱情故事"
        />
        {latest.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-5">
            {latest.map((item) => (
              <MediaCard key={item.id} item={item} showDesc />
            ))}
          </div>
        ) : (
          <p className="text-sm text-foreground-500">暂无更新内容，请稍后刷新。</p>
        )}
      </section>

      <section className="w-full px-4 md:px-8 mt-14 md:mt-20">
        <div className="rounded-lg bg-secondary-100 border border-background-200 p-6 md:p-12">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start">
            <div className="lg:col-span-2">
              <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950">
                关于爱情岛
              </h2>
              <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
                爱情岛是一个专注爱情题材的综合影视平台。我们持续收录来自中国、欧美、日韩等地区的爱情电影与爱情电视剧，
                涵盖最新上映、经典重温与口碑热门作品。在这里，你可以快速浏览分类影片、查看详细剧情介绍，
                并通过在线播放演示体验了解每一部作品。
              </p>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                温馨提示：本站内容均为演示数据，播放功能仅为前端模拟演示，不提供真实影片播放服务，
                所有资源仅用于产品功能展示。
              </p>
              <Link
                to="/about"
                className="mt-6 inline-flex items-center gap-2 px-5 h-10 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                了解更多
                <i className="ri-arrow-right-s-line text-lg"></i>
              </Link>
            </div>
            <div className="grid grid-cols-2 lg:grid-cols-1 gap-4">
              {[
                { label: "收录影视", value: mediaList.length, icon: "ri-file-list-3-line" },
                { label: "覆盖地区", value: 4, icon: "ri-earth-line" },
                { label: "平均评分", value: "8.5", icon: "ri-star-line" },
                { label: "持续更新", value: "每日", icon: "ri-refresh-line" },
              ].map((stat) => (
                <div
                  key={stat.label}
                  className="flex items-center gap-3 p-4 rounded-lg bg-background-50 border border-background-200"
                >
                  <span className="w-10 h-10 rounded-md bg-accent-100 text-accent-700 flex items-center justify-center text-lg">
                    <i className={stat.icon}></i>
                  </span>
                  <div>
                    <p className="font-heading text-lg font-bold text-foreground-950">{stat.value}</p>
                    <p className="text-xs text-foreground-600">{stat.label}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}